import React from 'react';
import {
	IonContent,
	IonPage,
	IonRefresher,
	IonRefresherContent,
	useIonAlert,
	useIonRouter,
} from '@ionic/react';
import { RouteComponentProps } from 'react-router';
import { Header, TabsOffset, Store, Oops } from 'components';
import { func, types } from 'utils';
import { _store, _update } from '_Store';

interface Props extends RouteComponentProps, types.StateProps {}
const Stores: React.FC<Props> = (props) => {
	React.useEffect(() => {
		_update.data('activeStore', {});
	}, []);

	const {
		__data: { stores },
		__auth: { user, isLoggedIn },
	} = _store.useState();

	const [presentAlert] = useIonAlert();
	const router = useIonRouter();

	const [q, setSearch] = React.useState('');
	const filteredVenues = React.useMemo(() => {
		return q
			? stores.filter((v) =>
					func.venueName(v).trim().toLowerCase().includes(q.toLowerCase())
				)
			: stores;
	}, [q, stores]);

	React.useEffect(() => {
		if (isLoggedIn) {
			const kyc = func.checkKYC(user);
			const text = !kyc.email ? 'email address' : 'phone number';
			if (!kyc.email || !kyc.phone) {
				presentAlert({
					header: `Please complete your account registration in your profile`,
					message: `Please add and verify your ${text}  `,
					buttons: [
						{ text: `Cancel` },
						{
							text: `Verify`,
							handler: () => {
								func.setStorageJson('edit_user', {
									from: props.location.pathname,
									edit: ['email'],
									option: 'promos',
								});
								router.push('/user');
							},
						},
					],
				});
			}
		}
		// eslint-disable-next-line
	}, [isLoggedIn, user]);

	return (
		<IonPage id="Stores">
			<Header
				{...props}
				showSearch={true}
				showSegments={false}
				search={{
					placeholder: 'Search restaurants',
					onSearch: (input) => setSearch(input),
				}}
			/>
			<IonContent
				fullscreen={false}
				className="bg-img"
				style={{ backgroundAttachment: 'fixed', height: '100%' }}
			>
				<IonRefresher
					slot="fixed"
					onIonRefresh={(e) => {
						_update.data('cache', { stores: Date.now() });
					}}
				>
					<IonRefresherContent></IonRefresherContent>
				</IonRefresher>
				{stores.length > 0 ? (
					<div className="p-3">
						<div
							className="fw-500 text-capitalize- mb-4"
							style={{ fontSize: 17 }}
						>
							🍗 All restaurants near you
						</div>

						{filteredVenues.map((store) => (
							<Store {...props} key={store.id} item={store} layout="list" />
						))}
					</div>
				) : (
					<Oops />
				)}
				<TabsOffset />
			</IonContent>
		</IonPage>
	);
};

export default Stores;
